<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import * as ls from "local-storage";

  export let _id;
  export let title;
  export let fullName;
  export let tel;
  export let customerType;
  export let email;
  export let companyName;

  let authData = {
    headers: { authorization: ls.get("jwt") },
  };

  onMount(() => {});

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/orders/with-cmt/${_id}`,
      authData
    );

    let usedIn = resItem?.data?.usedIn;

    if (usedIn) {
      alert(
        `${fullName} is being used in the Orders database.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${fullName}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/cmts/${_id}`, authData)
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div style="min-width: 10rem; max-width: 10rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a href={`/cmts/${_id}`} use:link class="text-base btn btn-gray-outline">
      <i class="fas fa-eye" />
    </a>
  </div>
  <div style="min-width: 17.5rem; max-width: 17.5rem;">
    {`${title} ${fullName}`}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">{tel}</div>
  <div style="min-width: 15rem; max-width: 15rem;">
    {email}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {customerType}
  </div>
  <div style="min-width: 22.5rem; max-width: 22.5rem;">
    {companyName}
  </div>
</div>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
